/**
 * Listing-card variant pills for single-option accessories (2–5 variants).
 * Combo listings (Standard Combo / Vlog Combo) stay split as real cards.
 * Care Refresh also gets a 3-Year combo (2-Year + 1-Year). PDP year cards stay Care-only.
 */
(function (root) {
  'use strict';

  var MAX_VARIANTS = 5;
  var YEAR_RE = /\d[\s-]*year/i;
  var CARE_RE = /care[\s-]*refresh/i;
  var COMBO_LISTING_RE = /\bcombo\b/i;
  var COMBO_KEY = 'combo';
  var COMBO_LABEL = '3-Year';
  var PLAN_NOTE_1 = 'New Coverage or Top-Up of Existing Plans (Up to 3 Years)';
  var PLAN_NOTE_2 = 'New Coverage Only.';
  var PLAN_NOTE_COMBO = 'New Coverage Only. Activate 2-Year Plan First before 1-Year Plan.';
  var COMBO_NOTE = PLAN_NOTE_COMBO;
  var COMBO_PROP_FIRST = 'Activate this 2-Year plan first';
  var COMBO_PROP_NEXT = 'Then activate this 1-Year plan';

  function textOf(product) {
    if (!product) return '';
    return [product.title, product.product_type, product.type, product.handle]
      .filter(Boolean)
      .join(' ');
  }

  function isCareRefresh(product) {
    return CARE_RE.test(textOf(product));
  }

  function pinCareRefreshFirst(products) {
    var list = Array.isArray(products) ? products : [];
    var care = [];
    var rest = [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (isCareRefresh(list[i])) care.push(list[i]);
      else rest.push(list[i]);
    }
    return care.concat(rest);
  }

  function variantsOf(product) {
    return product && Array.isArray(product.variants) ? product.variants : [];
  }

  function isSingleOption(variants) {
    return variants.every(function (variant) {
      return variant && !variant.option2;
    });
  }

  function yearOf(variant) {
    var match = String((variant && variant.title) || '').match(/(\d+)\s*[- ]*year/i);
    return match ? parseInt(match[1], 10) : 0;
  }

  function variantImage(variant) {
    if (!variant) return '';
    if (variant.featured_image && variant.featured_image.src) return String(variant.featured_image.src);
    if (typeof variant.featured_image === 'string' && variant.featured_image) return variant.featured_image;
    if (variant.image) return String(variant.image);
    return '';
  }

  function isComboListing(product) {
    if (isCareRefresh(product)) return false;
    return variantsOf(product).some(function (variant) {
      return COMBO_LISTING_RE.test(String((variant && variant.title) || ''));
    });
  }

  function shouldSplitAsCards(product) {
    return isComboListing(product) && variantsOf(product).length > 1;
  }

  function splitCardVariants(product) {
    if (!shouldSplitAsCards(product)) return [];
    return variantsOf(product).filter(function (variant) {
      return variant && variant.id && dollarsOf(variant.price) > 0;
    });
  }

  function eligibleVariants(product) {
    if (shouldSplitAsCards(product)) return [];
    var variants = variantsOf(product);
    if (variants.length < 2 || variants.length > MAX_VARIANTS) return [];
    if (!isSingleOption(variants)) return [];
    return variants.filter(function (variant) {
      return variant && variant.id && variant.price != null;
    });
  }

  function pillLabel(title) {
    return String(title || '')
      .replace(/\s+plan$/i, '')
      .trim();
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function dollarsOf(value) {
    var amount = parseFloat(String(value == null ? '' : value).replace(/,/g, ''));
    return isFinite(amount) ? amount : 0;
  }

  function noteForPlan(option) {
    if (!option) return '';
    if (option.combo) return PLAN_NOTE_COMBO;
    if (option.year === 1) return PLAN_NOTE_1;
    if (option.year === 2) return PLAN_NOTE_2;
    return '';
  }

  function planOptions(product) {
    var variants = eligibleVariants(product);
    var care = isCareRefresh(product);
    var options = variants.map(function (variant) {
      var option = {
        key: String(variant.id),
        label: pillLabel(variant.title),
        year: yearOf(variant),
        variantIds: [variant.id],
        price: String(variant.price),
        compare: variant.compare_at_price ? String(variant.compare_at_price) : '',
        available: !!variant.available,
        combo: false,
        image: variantImage(variant),
      };
      option.note = care ? noteForPlan(option) : '';
      return option;
    });
    if (!care) return options;
    var oneYear = variants.find(function (variant) {
      return yearOf(variant) === 1;
    });
    var twoYear = variants.find(function (variant) {
      return yearOf(variant) === 2;
    });
    if (oneYear && twoYear) {
      var combo = {
        key: COMBO_KEY,
        label: COMBO_LABEL,
        year: 3,
        variantIds: [twoYear.id, oneYear.id],
        price: (dollarsOf(twoYear.price) + dollarsOf(oneYear.price)).toFixed(2),
        compare: '',
        available: !!(oneYear.available && twoYear.available),
        combo: true,
        image: variantImage(twoYear) || variantImage(oneYear),
      };
      combo.note = noteForPlan(combo);
      options.push(combo);
    }
    return options;
  }

  function selectedVariant(product) {
    var variants = eligibleVariants(product);
    if (!variants.length) return null;
    return (
      variants.find(function (variant) {
        return variant.available;
      }) || variants[0]
    );
  }

  function selectedKey(product, selected) {
    if (selected && selected.key) return String(selected.key);
    if (selected && selected.id) return String(selected.id);
    var current = selectedVariant(product);
    return current ? String(current.id) : '';
  }

  function pillsHtml(product, selected) {
    var options = planOptions(product);
    if (!options.length) return '';
    var currentKey = selectedKey(product, selected);
    var buttons = options
      .map(function (option) {
        var selectedClass = option.key === currentKey ? ' is-selected' : '';
        return (
          '<button type="button" class="card__plan-pill' +
          selectedClass +
          '"' +
          optionAttrs(option) +
          '>' +
          escapeHtml(option.label) +
          '</button>'
        );
      })
      .join('');
    return (
      '<div class="card__plan-wrap">' +
      '<div class="card__plan-pills" role="group" aria-label="Options">' +
      buttons +
      '</div>' +
      '</div>'
    );
  }

  function optionAttrs(option) {
    return (
      ' data-d1-plan-pill data-plan="' +
      escapeHtml(option.key) +
      '" data-variant-id="' +
      escapeHtml(option.variantIds[0]) +
      '" data-variant-ids="' +
      escapeHtml(option.variantIds.join(',')) +
      '" data-price="' +
      escapeHtml(option.price) +
      '" data-compare="' +
      escapeHtml(option.compare) +
      '" data-available="' +
      (option.available ? 'true' : 'false') +
      '" data-combo="' +
      (option.combo ? 'true' : 'false') +
      '" data-image="' +
      escapeHtml(option.image || '') +
      '" data-note="' +
      escapeHtml(option.note || '') +
      '" data-label="' +
      escapeHtml(option.label) +
      '"' +
      (option.available ? '' : ' disabled')
    );
  }

  function cardsHtml(product, selected) {
    var options = planOptions(product);
    if (!options.length) return '';
    var currentKey = selectedKey(product, selected);
    var image = product.image ? String(product.image) : '';
    var cards = options
      .map(function (option) {
        var selectedClass = option.key === currentKey ? ' is-selected' : '';
        var statusClass = option.available
          ? 'product__inventory--available'
          : 'product__inventory--soldout';
        var statusLabel = option.available ? 'In-Stock' : 'Sold Out';
        var imageHtml = image
          ? '<div class="variant-card__image"><img src="' +
            escapeHtml(image) +
            '" alt="" width="150" height="150" loading="lazy"></div>'
          : '';
        var noteHtml = option.note
          ? '<div class="variant-card__description"><p>' + escapeHtml(option.note) + '</p></div>'
          : '';
        return (
          '<div class="variant-card-wrapper">' +
          '<button type="button" class="variant-card' +
          selectedClass +
          '"' +
          optionAttrs(option) +
          '>' +
          '<div class="variant-card__badges">' +
          '<span class="variant-card__status ' +
          statusClass +
          '">' +
          escapeHtml(statusLabel) +
          '</span></div>' +
          '<div class="variant-card__main">' +
          imageHtml +
          '<div class="variant-card__info">' +
          '<p class="variant-card__title">' +
          escapeHtml(option.label) +
          '</p>' +
          '<p class="variant-card__price"><span class="price-item price-item--regular">' +
          escapeHtml(formatMoney(dollarsOf(option.price) * 100)) +
          '</span></p>' +
          '</div></div>' +
          noteHtml +
          '</button></div>'
        );
      })
      .join('');
    return (
      '<div class="card__plan-wrap d1-care-plan-cards">' +
      '<div class="variant-card-grid" role="group" aria-label="Coverage period">' +
      cards +
      '</div></div>'
    );
  }

  function formatMoney(cents) {
    var rootEl =
      root.document && typeof root.document.querySelector === 'function'
        ? root.document.querySelector('[data-related-tabs]')
        : null;
    var fmt = rootEl && rootEl.dataset ? rootEl.dataset.moneyFormat : '';
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return root.Shopify.formatMoney(cents, fmt || '${{amount}}');
    }
    var parts = (Number(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  function setPrice(priceEl, priceDollars, compareDollars) {
    if (!priceEl) return '';
    // money_without_currency is "20,469.00". parseFloat stops at the comma and shows $20.00.
    var price = dollarsOf(priceDollars);
    var compare = compareDollars ? dollarsOf(compareDollars) : 0;
    if (!isFinite(price)) return '';
    while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
    if (isFinite(compare) && compare > price) {
      var sale = root.document.createElement('span');
      sale.className = 'card__sale-price';
      sale.textContent = formatMoney(price * 100);
      var was = root.document.createElement('span');
      was.className = 'card__compare-price';
      was.textContent = formatMoney(compare * 100);
      priceEl.appendChild(sale);
      priceEl.appendChild(was);
      return sale.textContent;
    }
    priceEl.textContent = formatMoney(price * 100);
    return priceEl.textContent;
  }

  function setCardImage(card, src) {
    if (!card || !src || typeof card.querySelector !== 'function') return;
    var img =
      card.querySelector('.d1-card-gallery__slide.is-active img') ||
      card.querySelector('.card__media img');
    if (!img) return;
    img.setAttribute('src', src);
    img.removeAttribute('srcset');
  }

  function setNote(rootEl, pill) {
    var note = rootEl && rootEl.querySelector ? rootEl.querySelector('.card__plan-note') : null;
    if (!note) return;
    var text = pill && pill.getAttribute ? pill.getAttribute('data-note') || '' : '';
    note.textContent = text;
    if (text) note.removeAttribute('hidden');
    else note.setAttribute('hidden', '');
  }

  function applyButtonIds(btn, pill) {
    if (!btn || btn.tagName !== 'BUTTON') return;
    var variantId = pill.getAttribute('data-variant-id');
    var variantIds = pill.getAttribute('data-variant-ids') || variantId;
    var available = pill.getAttribute('data-available') === 'true';
    btn.dataset.variantId = variantId;
    btn.setAttribute('data-variant-id', variantId);
    btn.dataset.variantIds = variantIds;
    btn.setAttribute('data-variant-ids', variantIds);
    btn.classList.remove('card__atc-btn--in-cart', 'is-just-added', 'card__atc-btn--sold-out');
    if (available) {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      var idle =
        root.D1AccessoryAtc && typeof root.D1AccessoryAtc.idleLabelOf === 'function'
          ? root.D1AccessoryAtc.idleLabelOf(btn)
          : btn.dataset.idleLabel || '+ Add';
      btn.textContent = idle;
    } else {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('card__atc-btn--sold-out');
      btn.textContent = 'Sold out';
    }
  }

  function applyPill(card, pill) {
    if (!card || !pill) return null;
    var variantId = pill.getAttribute('data-variant-id');
    var variantIds = pill.getAttribute('data-variant-ids') || variantId;
    var available = pill.getAttribute('data-available') === 'true';
    var combo = pill.getAttribute('data-combo') === 'true';
    var priceEl =
      card.querySelector('.card__price') ||
      card.querySelector('.price-item--regular') ||
      card.querySelector('.price .price-item');
    var btn =
      card.querySelector('.card__atc-btn[data-variant-id]') ||
      card.querySelector('.quick-add__submit[data-variant-id]');
    var form = card.querySelector('form[action*="/cart/add"]');
    var idInput = form ? form.querySelector('input[name="id"], input.product-variant-id') : null;
    var heading = card.querySelector('.card__heading a');
    var handleMatch =
      heading && heading.getAttribute
        ? (heading.getAttribute('href') || '').match(/\/products\/([^/?#]+)/)
        : null;
    var href = handleMatch
      ? '/products/' + handleMatch[1] + '?variant=' + encodeURIComponent(variantId)
      : '';

    card.querySelectorAll('[data-d1-plan-pill]').forEach(function (other) {
      other.classList.toggle('is-selected', other === pill);
    });

    setPrice(priceEl, pill.getAttribute('data-price'), pill.getAttribute('data-compare'));
    setNote(card, pill);
    setCardImage(card, pill.getAttribute('data-image'));

    if (href) {
      card.querySelectorAll('.card__heading a, a.card__media').forEach(function (link) {
        link.setAttribute('href', href);
      });
    }

    applyButtonIds(btn, pill);
    if (idInput) {
      idInput.disabled = false;
      idInput.value = variantId;
    }
    if (form) {
      if (combo) form.setAttribute('data-d1-care-combo-ids', variantIds);
      else form.removeAttribute('data-d1-care-combo-ids');
    }
    return { variantId: variantId, variantIds: variantIds, available: available, combo: combo };
  }

  function productFormsOf(rootEl) {
    var info = rootEl && rootEl.closest ? rootEl.closest('product-info, .product') : null;
    var scope = info || root.document;
    var found = [];
    if (scope && typeof scope.querySelectorAll === 'function') {
      scope.querySelectorAll('form[action*="/cart/add"], form[data-type="add-to-cart-form"]').forEach(function (form) {
        found.push(form);
      });
    }
    if (!found.length && root.document && typeof root.document.querySelector === 'function') {
      var fallback = root.document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
      if (fallback) found.push(fallback);
    }
    return found;
  }

  function productFormOf(rootEl) {
    return productFormsOf(rootEl)[0] || null;
  }

  function parseIds(raw) {
    return String(raw || '')
      .split(',')
      .map(function (part) {
        return parseInt(part, 10);
      })
      .filter(function (id) {
        return id > 0;
      });
  }

  function selectedComboIds(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return [];
    var pill = scope.querySelector('[data-d1-plan-pill][data-combo="true"].is-selected');
    return pill ? parseIds(pill.getAttribute('data-variant-ids')) : [];
  }

  function comboIdsOf(el) {
    var ids = parseIds(el && el.getAttribute ? el.getAttribute('data-d1-care-combo-ids') : '');
    if (ids.length < 2 && el && el.closest) {
      var host = el.closest('product-form, form, product-info, .product, .card');
      if (host && host.getAttribute) ids = parseIds(host.getAttribute('data-d1-care-combo-ids'));
      if (ids.length < 2) ids = selectedComboIds(host);
    }
    if (ids.length < 2) ids = selectedComboIds(root.document);
    return ids;
  }

  function comboCartItems(form) {
    var ids = comboIdsOf(form);
    if (ids.length < 2) return [];
    var qtyInput = form && form.querySelector ? form.querySelector('[name="quantity"]') : null;
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var extra = formProperties(form);
    return ids.map(function (id, index) {
      var properties = {};
      Object.keys(extra).forEach(function (key) {
        properties[key] = extra[key];
      });
      properties.Activation = index === 0 ? COMBO_PROP_FIRST : COMBO_PROP_NEXT;
      return { id: id, quantity: quantity, properties: properties };
    });
  }

  function formProperties(form) {
    var props = {};
    if (!form || typeof form.querySelectorAll !== 'function') return props;
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      if (input.disabled) return;
      var match = String(input.name || '').match(/^properties\[([^\]]+)\]$/);
      if (match) props[match[1]] = input.value;
    });
    return props;
  }

  function appendComboFormData(formData, form) {
    var items = comboCartItems(form);
    if (!items.length || !formData || typeof formData.append !== 'function') return false;
    items.forEach(function (item, index) {
      formData.append('items[' + index + '][id]', String(item.id));
      formData.append('items[' + index + '][quantity]', String(item.quantity));
      Object.keys(item.properties || {}).forEach(function (key) {
        formData.append('items[' + index + '][properties][' + key + ']', item.properties[key]);
      });
    });
    return true;
  }

  function stickyPlanLabel(pill) {
    if (!pill && root.document && typeof root.document.querySelector === 'function') {
      pill = root.document.querySelector('[data-d1-care-plan-root] [data-d1-plan-pill].is-selected');
    }
    if (!pill) return '';
    var combo =
      pill.getAttribute &&
      (pill.getAttribute('data-combo') === 'true' || pill.getAttribute('data-plan') === COMBO_KEY);
    var label = combo ? COMBO_LABEL : '';
    if (!label && pill.getAttribute) {
      var named = String(pill.getAttribute('data-label') || '').trim();
      if (named && named !== 'true' && named !== 'false') label = named;
    }
    if (!label && pill.querySelector) {
      var titleEl = pill.querySelector('.variant-card__title');
      if (titleEl) label = String(titleEl.textContent || '').replace(/\s+/g, ' ').trim();
    }
    if (!label) label = String(pill.textContent || '').replace(/\s+/g, ' ').trim();
    if (!label) return '';
    if (!/plan$/i.test(label)) label += ' Plan';
    return label;
  }

  function setProductTitleVariant(label) {
    if (!label || !root.document || typeof root.document.querySelectorAll !== 'function') return;
    var nodes = root.document.querySelectorAll('.product-title-variant');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = label;
  }

  function setStickyPlanLabel(pill) {
    var label = stickyPlanLabel(pill);
    if (!label) return '';
    var subtitle =
      root.document && typeof root.document.querySelector === 'function'
        ? root.document.querySelector('.d1-sticky-atc__subtitle')
        : null;
    if (subtitle) subtitle.textContent = label;
    setProductTitleVariant(label);
    return label;
  }

  function setProductPrice(rootEl, priceDollars) {
    var formatted = formatMoney(dollarsOf(priceDollars) * 100);
    var info = rootEl.closest('product-info, .product');
    var priceEl = info
      ? info.querySelector('.price-item--regular') ||
        info.querySelector('.price .price-item') ||
        info.querySelector('.product__price')
      : null;
    if (priceEl) priceEl.textContent = formatted;
    var sticky = root.document && typeof root.document.querySelector === 'function'
      ? root.document.querySelector('.d1-sticky-atc__price .price-item')
      : null;
    if (sticky) sticky.textContent = formatted;
  }

  function applyProductPill(rootEl, pill) {
    if (!rootEl || !pill) return null;
    var variantId = pill.getAttribute('data-variant-id');
    var variantIds = pill.getAttribute('data-variant-ids') || variantId;
    var combo = pill.getAttribute('data-combo') === 'true';
    var forms = productFormsOf(rootEl);

    rootEl.querySelectorAll('[data-d1-plan-pill]').forEach(function (other) {
      other.classList.toggle('is-selected', other === pill);
    });
    setNote(rootEl, pill);
    setProductPrice(rootEl, pill.getAttribute('data-price'));
    setStickyPlanLabel(pill);

    forms.forEach(function (form) {
      var idInput = form.querySelector('input[name="id"], input.product-variant-id');
      if (idInput) {
        idInput.disabled = false;
        idInput.value = variantId;
      }
      if (combo) form.setAttribute('data-d1-care-combo-ids', variantIds);
      else form.removeAttribute('data-d1-care-combo-ids');
      var host = form.closest('product-form');
      if (host) {
        if (combo) host.setAttribute('data-d1-care-combo-ids', variantIds);
        else host.removeAttribute('data-d1-care-combo-ids');
      }
    });
    if (!combo && variantId && root.history && root.history.replaceState) {
      try {
        var url = new URL(root.location.href);
        url.searchParams.set('variant', variantId);
        root.history.replaceState({}, '', url);
      } catch (err) {}
    }
    return { variantId: variantId, variantIds: variantIds, combo: combo };
  }

  function parseProductJson(rootEl) {
    var node = rootEl.querySelector('[data-d1-care-plan-product]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function currentUrlVariantId() {
    try {
      return new URL(root.location.href).searchParams.get('variant') || '';
    } catch (err) {
      return '';
    }
  }

  function mountProductRoot(rootEl) {
    if (!rootEl || typeof rootEl.querySelector !== 'function') return;
    if (rootEl.querySelector('[data-d1-plan-pill]')) return;
    var product = parseProductJson(rootEl);
    if (!product || !planOptions(product).length) return;
    var selected = { key: currentUrlVariantId() || selectedKey(product) };
    var card = rootEl.closest ? rootEl.closest('.card') : null;
    var html = card ? pillsHtml(product, selected) : cardsHtml(product, selected);
    var mount = rootEl.querySelector('[data-d1-care-plan-mount]') || rootEl;
    mount.insertAdjacentHTML('afterbegin', html);
    var selectedPill =
      rootEl.querySelector('[data-d1-plan-pill].is-selected') ||
      rootEl.querySelector('[data-d1-plan-pill]');
    if (!selectedPill) return;
    if (card) applyPill(card, selectedPill);
    else applyProductPill(rootEl, selectedPill);
  }

  function mountAllProductRoots() {
    if (!root.document || typeof root.document.querySelectorAll !== 'function') return;
    root.document.querySelectorAll('[data-d1-care-plan-root]').forEach(function (rootEl) {
      try {
        mountProductRoot(rootEl);
      } catch (err) {}
    });
  }

  function observeProductRoots() {
    if (!root.document || typeof root.MutationObserver !== 'function') return;
    var observer = new root.MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes || [], function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-d1-care-plan-root]')) mountProductRoot(node);
          if (typeof node.querySelectorAll === 'function') {
            node.querySelectorAll('[data-d1-care-plan-root]').forEach(mountProductRoot);
          }
        });
      });
    });
    observer.observe(root.document.documentElement || root.document.body, {
      childList: true,
      subtree: true,
    });
  }

  function refreshCartDrawer() {
    var cart = root.document.querySelector('cart-drawer') || root.document.querySelector('cart-notification');
    if (!cart || typeof cart.getSectionsToRender !== 'function') return Promise.resolve();
    var sections = cart.getSectionsToRender().map(function (section) {
      return section.id;
    });
    return root
      .fetch(root.location.pathname + '?sections=' + sections.join(','))
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (html) {
        if (!html) return;
        cart.classList.remove('is-empty');
        cart.renderContents({ sections: html, id: null });
      })
      .catch(function () {});
  }

  function comboItems(ids) {
    return ids.map(function (id, index) {
      return {
        id: id,
        quantity: 1,
        properties: {
          Activation:
            index === 0 ? COMBO_PROP_FIRST : COMBO_PROP_NEXT,
        },
      };
    });
  }

  function onProductFormSubmit(event) {
    var form = event.target;
    if (!form || !form.getAttribute) return;
    var raw = form.getAttribute('data-d1-care-combo-ids');
    if (!raw) return;
    var ids = String(raw)
      .split(',')
      .map(function (part) {
        return parseInt(part, 10);
      })
      .filter(function (id) {
        return id > 0;
      });
    if (ids.length < 2) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var productForm = form.closest('product-form');
    var submit = productForm && productForm.querySelector('[type="submit"]');
    if (submit) {
      submit.setAttribute('aria-disabled', 'true');
      submit.classList.add('loading');
    }
    root
      .fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: comboItems(ids) }),
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Add failed');
        return refreshCartDrawer();
      })
      .catch(function () {})
      .then(function () {
        if (!submit) return;
        submit.classList.remove('loading');
        submit.removeAttribute('aria-disabled');
      });
  }

  function syncCardCart(card) {
    if (!root.D1AccessoryAtc || typeof root.D1AccessoryAtc.syncFromCart !== 'function' || !root.fetch) {
      return;
    }
    root
      .fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        root.D1AccessoryAtc.syncFromCart(card, cart);
      })
      .catch(function () {});
  }

  function onClick(event) {
    var pill = event.target && event.target.closest ? event.target.closest('[data-d1-plan-pill]') : null;
    if (!pill || pill.disabled) return;
    event.preventDefault();
    event.stopPropagation();
    var card = pill.closest('.card');
    if (card) {
      applyPill(card, pill);
      syncCardCart(card);
      return;
    }
    var rootEl = pill.closest('[data-d1-care-plan-root]');
    if (rootEl) applyProductPill(rootEl, pill);
  }

  root.D1CardVariantPills = {
    MAX_VARIANTS: MAX_VARIANTS,
    COMBO_KEY: COMBO_KEY,
    COMBO_LABEL: COMBO_LABEL,
    PLAN_NOTE_1: PLAN_NOTE_1,
    PLAN_NOTE_2: PLAN_NOTE_2,
    PLAN_NOTE_COMBO: PLAN_NOTE_COMBO,
    COMBO_NOTE: COMBO_NOTE,
    noteForPlan: noteForPlan,
    COMBO_PROP_FIRST: COMBO_PROP_FIRST,
    COMBO_PROP_NEXT: COMBO_PROP_NEXT,
    isCareRefresh: isCareRefresh,
    pinCareRefreshFirst: pinCareRefreshFirst,
    isComboListing: isComboListing,
    shouldSplitAsCards: shouldSplitAsCards,
    splitCardVariants: splitCardVariants,
    yearOf: yearOf,
    eligibleVariants: eligibleVariants,
    planOptions: planOptions,
    pillLabel: pillLabel,
    selectedVariant: selectedVariant,
    pillsHtml: pillsHtml,
    cardsHtml: cardsHtml,
    setPrice: setPrice,
    applyPill: applyPill,
    applyProductPill: applyProductPill,
    stickyPlanLabel: stickyPlanLabel,
    setStickyPlanLabel: setStickyPlanLabel,
    comboIdsOf: comboIdsOf,
    comboCartItems: comboCartItems,
    appendComboFormData: appendComboFormData,
    mountAllProductRoots: mountAllProductRoots,
  };

  if (root.document && root.document.addEventListener) {
    root.document.addEventListener('click', onClick, true);
    root.document.addEventListener('submit', onProductFormSubmit, true);
    observeProductRoots();
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', mountAllProductRoots);
    } else {
      mountAllProductRoots();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
